import { render, staticRenderFns } from "./SortableCart.vue?vue&type=template&id=6f2c592c&scoped=true"
import script from "./SortableCart.vue?vue&type=script&lang=js"
export * from "./SortableCart.vue?vue&type=script&lang=js"
import style0 from "./SortableCart.vue?vue&type=style&index=0&id=6f2c592c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c592c",
  null
  
)

export default component.exports